import { setToDateMonthYearInWords } from "../../../helpers";

const TotalCustomerChartLogic = () => {
  const xAxisFormatter = (tick) => {
    return setToDateMonthYearInWords(tick);
  };

  return {
    xAxisFormatter,
  };
};

export default TotalCustomerChartLogic;
